export default {"src":"/_next/static/media/shipstation.c7ede563.gif","height":170,"width":300,"blurWidth":0,"blurHeight":0};